import axios from "axios";
import {Base_URL} from "../url"


const API_URL = "http://192.168.29.242:5090/api/TripDetails"; 

export const saveTripDetails = async (tripData) => {
  try {
    const response = await axios.post(`${Base_URL}/TripDetails`, tripData);
    console.log(response)
    return response.data;

  } catch (error) {
    throw error.response?.data || "Error saving trip details!";
  }
};
